import { render, staticRenderFns } from "./TicketManagement.vue?vue&type=template&id=7dd8dc75&scoped=true&"
import script from "./TicketManagement.vue?vue&type=script&lang=js&"
export * from "./TicketManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd8dc75",
  null
  
)

export default component.exports